import React from "react";
import classNames from "classnames";
import { Icons, Tooltip } from "../..";
export const Label = ({
  className,
  required,
  tooltip,
  children,
  ...props
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("tui-label", {
      [className]: className
    })
  }, /*#__PURE__*/React.createElement("label", props, children, required && /*#__PURE__*/React.createElement("span", {
    className: "tui-label--required"
  }, "*"), tooltip && /*#__PURE__*/React.createElement(Tooltip, {
    label: tooltip
  }, /*#__PURE__*/React.createElement("span", {
    className: "tui-label--tooltip"
  }, /*#__PURE__*/React.createElement(Icons.Info, null)))));
};
Label.displayName = "Label";
Label.defaultProps = {
  required: false,
  tooltip: "",
  className: ""
};
//# sourceMappingURL=Label.js.map